import React from 'react';
import { Popconfirm, Icon } from 'antd';
import cn from 'classnames';
import PersonWithPosition from '../PersonWithPosition/PersonWithPosition';
import tableStyles from '../table/table.module.scss';
import styles from './RemovableWorker.module.scss';

const Title = ({ title }) => {
  return <div className={styles.deleteConfirmText}>{title}</div>;
};

const RemovableWorker = ({
  allowDelete,
  single = false,
  counter,
  onConfirm,
  deleteConfirmText,
  person,
}) => {
  return (
    <div
      className={cn(tableStyles.tdItem, styles.root, {
        [styles.single]: single,
      })}
    >
      {counter ? (
        <div className={styles.workerWrap}>
          <PersonWithPosition person={person} />
          <span className={styles.counter}>{counter}</span>
        </div>
      ) : (
        <PersonWithPosition person={person} />
      )}

      {allowDelete && (
        <Popconfirm
          className={styles.deleteButton}
          onClick={(e) => {
            e.stopPropagation();
          }}
          title={<Title title={deleteConfirmText} />}
          okText="Да"
          onConfirm={onConfirm}
        >
          <Icon
            type="minus-circle"
            className={cn('dspx-danger-button', styles.deleteIcon)}
          />
        </Popconfirm>
      )}
    </div>
  );
};

export default RemovableWorker;
